// tslint:disable:no-empty
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
// Using a non-decriptive variable name deliberately to avoid leaking
// what that variable is doing very easily. hdc === Helios DC
export const heliosOmnitureTracking = {
    get() {
        if (ExecutionEnvironment.canUseDOM) {
            return window.hdc || 0;
        }
        return 0;
    },
    set(dc) {
        if (ExecutionEnvironment.canUseDOM) {
            window.hdc = dc;
        }
    }
};
